import { withProps } from 'recompose'

import Testimonial from 'layouts/Testimonial'

import nameIconSrc from './guillaume-cabane.svg'
import faceIconSrc from './guillaume_face.jpg'

export default withProps({
  role: 'VP Growth',
  nameIconSrc,
  faceIconSrc,
  quote: `
    Drift has helped our team become far more proactive when communicating with our site visitors. It was so easy to get started - just one piece of code installed in 2 minutes and we were chatting with our future customers!
  `,
  company: 'Segment',
})(Testimonial)
